"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reducer = void 0;
class Reducer {
    constructor(opts) {
        this.state = structuredClone(opts.initialValue);
        this.lastConfirmedState = structuredClone(opts.initialValue);
        this.lastConfirmedSeq = 0;
        this.db = opts.db;
        this.reducer = opts.reducer;
        this.key = opts.key;
        this.callback = opts.callback;
        this.sizeThreshold = opts.sizeThreshold || 30;
        this.onSequenceValue = this.onSequenceValue.bind(this);
        this.onSize = this.onSize.bind(this);
        this.dispatch = this.dispatch.bind(this);
        this.db.subscribe(this.key, this.onSequenceValue, this.onSize);
    }
    dispose() {
        this.db.unsubscribe(this.key, this.onSequenceValue, this.onSize);
    }
    dispatch(action) {
        this.state = this.reducer(this.state, action);
        this.db.send({ type: "push", action: { "type": "append" }, value: { "apply": action }, key: this.key });
        this.callback(this.state);
    }
    onSequenceValue(sequenceValue) {
        if (sequenceValue.seq <= this.lastConfirmedSeq) {
            return;
        }
        const value = sequenceValue.value;
        if (value.reset !== undefined) {
            this.lastConfirmedState = value.reset;
            this.lastConfirmedSeq = sequenceValue.seq;
            this.state = structuredClone(this.lastConfirmedState);
            this.callback(this.state);
            return;
        }
        if (value.apply !== undefined) {
            this.lastConfirmedState = this.reducer(this.lastConfirmedState, value.apply);
            this.lastConfirmedSeq = sequenceValue.seq;
            this.state = structuredClone(this.lastConfirmedState);
            this.callback(this.state);
            return;
        }
        console.log("Unknown message", sequenceValue.value);
    }
    onSize(size) {
        if (size > this.sizeThreshold && this.lastConfirmedSeq !== 0) {
            this.db?.send({
                type: "push",
                action: { "type": "compact", seq: this.lastConfirmedSeq },
                value: { "reset": this.lastConfirmedState },
                key: this.key
            });
        }
    }
}
exports.Reducer = Reducer;
